import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './SelectionPage.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://hb-api.kalkut.in';
 
const SelectionPage = () => {
  const [selectedFile, setSelectedFile] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const audioFiles = [
    { value: 'sounds/Normal_Heart_Sound.mp3', label: 'Normal_Heart_Sound.mp3' },
    { value: 'sounds/Heart_Failure_Sound.mp3', label: 'Heart_Failure_Sound.mp3' }
  ];

  const handleAnalyze = async () => {
    if (!selectedFile) {
      setError('Please select a file');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const response = await axios.get(`${API_URL}/hb?filename=${selectedFile}`);
      navigate('/results', { state: { analysisData: response.data } });
    } catch (err) {
      console.error('Analysis error:', err);
      setError('Failed to analyze the file. Please try again.');
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && (
        <div className="fullscreen-loader">
          <div className="loader-content">
            <div className="loader-spinner"></div>
            <div className="loader-text">Processing Audio File</div>
            <div className="loader-subtext">Analyzing heartbeat patterns, please wait...</div>
          </div>
        </div>
      )}

      {!isLoading && (
        <div className="selection-container">
          <div className="selection-card">
            <h1 className="selection-title">Heart Beat Analyzer</h1>
            <p className="selection-subtitle">Select a heart sound file to analyze</p>

            {error && (
              <div className="error-message">
                {error}
              </div>
            )}

            <div className="selection-form">
              <label className="form-label">Choose Audio File</label>
              <select
                className="form-select"
                value={selectedFile}
                onChange={(e) => {
                  setSelectedFile(e.target.value);
                  setError('');
                }}
              >
                <option value="">-- Select a file --</option>
                {audioFiles.map((file) => (
                  <option key={file.value} value={file.value}>
                    {file.label}
                  </option>
                ))}
              </select>

              <button
                className="analyze-btn"
                onClick={handleAnalyze}
                disabled={!selectedFile || isLoading}
              >
                Analyze Heart Sound
              </button>
            </div>
          </div>

          {/* Open Source Model Info */}
          <div className="model-info-card">
            <div className="model-info-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                <path d="M2 17l10 5 10-5"/>
                <path d="M2 12l10 5 10-5"/>
              </svg>
            </div>
            <div className="model-info-content">
              <h3 className="model-info-title">Open Source AI Model</h3>
              <p className="model-info-description">
                The cardiac anomaly detection model powering this application is freely available for research and educational purposes.
              </p>
              <a
                href="https://huggingface.co/ai-mitra/heartbeat-anomaly-detector"
                target="_blank"
                rel="noopener noreferrer"
                className="model-info-link"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm-.5 4.5c.69 0 1.25.56 1.25 1.25S12.19 7 11.5 7 10.25 6.44 10.25 5.75 10.81 4.5 11.5 4.5zm.5 3.5c.69 0 1.25.56 1.25 1.25v7.5c0 .69-.56 1.25-1.25 1.25s-1.25-.56-1.25-1.25v-7.5c0-.69.56-1.25 1.25-1.25z"/>
                </svg>
                View on Hugging Face
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                  <polyline points="15 3 21 3 21 9"/>
                  <line x1="10" y1="14" x2="21" y2="3"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SelectionPage;
